/* Cajé 2026 — dependency-free slideshow + carousel custom elements */
(function () {
  if (customElements.get('caje-slideshow')) return;

  class CajeSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-caje-slide]'));
      if (this.slides.length < 2) {
        if (!this.hasAttribute('data-keep-arrows')) this.hideArrows();
        return;
      }
      this.index = 0;
      this.interval = parseInt(this.dataset.interval || '6000', 10);
      this.querySelectorAll('[data-caje-prev]').forEach(b => b.addEventListener('click', () => this.go(-1, true)));
      this.querySelectorAll('[data-caje-next]').forEach(b => b.addEventListener('click', () => this.go(1, true)));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.render();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && this.dataset.autoplay !== 'false') this.start();
    }
    disconnectedCallback() { this.stop(); }
    hideArrows() { this.querySelectorAll('[data-caje-prev],[data-caje-next]').forEach(b => b.style.display = 'none'); }
    start() { this.stop(); this.timer = setInterval(() => this.go(1), this.interval); }
    stop() { if (this.timer) clearInterval(this.timer); this.timer = null; }
    go(dir, user) { this.index = (this.index + dir + this.slides.length) % this.slides.length; this.render(); if (user) this.start(); }
    render() {
      this.slides.forEach((s, i) => {
        s.style.opacity = i === this.index ? '1' : '0';
        s.style.pointerEvents = i === this.index ? 'auto' : 'none';
        s.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
      });
    }
  }

  class CajeCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-caje-track]');
      if (!this.track) return;
      this.querySelectorAll('[data-caje-prev]').forEach(b => b.addEventListener('click', () => this.page(-1)));
      this.querySelectorAll('[data-caje-next]').forEach(b => b.addEventListener('click', () => this.page(1)));
      /* let vertical wheel scroll the page, never trap it in the horizontal track */
      this.track.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          e.preventDefault();
          window.scrollBy({ top: e.deltaY });
        }
      }, { passive: false });
    }
    page(dir) {
      var item = this.track.querySelector(':scope > *');
      var step = item ? item.getBoundingClientRect().width + 1 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
  }

  customElements.define('caje-slideshow', CajeSlideshow);
  customElements.define('caje-carousel', CajeCarousel);

  /* Quick add-to-cart: post via fetch, then nudge theme cart UI */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-caje-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = 'ADDING…'; btn.disabled = true; }
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
      if (btn) { btn.textContent = 'ADDED ✓'; setTimeout(function () { btn.textContent = btn.dataset.label; btn.disabled = false; }, 1600); }
    }).catch(function () { form.submit(); });
  });

  /* Free-shipping progress bar: injects into Horizon's cart drawer */
  (function () {
    var src = document.querySelector('[data-caje-freeship]');
    var THRESHOLD = src ? parseInt(src.getAttribute('data-caje-freeship'), 10) * 100 : 5000;
    if (!THRESHOLD) return;

    function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

    function renderBar(total) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var host = drawer.querySelector('dialog') || drawer;
      var bar = host.querySelector('.caje-freeship');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'caje-freeship';
        bar.innerHTML = '<div class="caje-freeship__txt"></div><div class="caje-freeship__rail"><span class="caje-freeship__fill"></span></div>';
        host.insertBefore(bar, host.firstChild);
      }
      var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
      var txt = bar.querySelector('.caje-freeship__txt');
      var fill = bar.querySelector('.caje-freeship__fill');
      if (total <= 0) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      txt.textContent = total >= THRESHOLD
        ? '🎉 You’ve unlocked FREE shipping!'
        : 'You’re ' + money(THRESHOLD - total) + ' away from FREE shipping';
      fill.style.width = pct + '%';
    }

    function refresh() {
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderBar(c.total_price); })
        .catch(function () {});
    }

    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('click', function () { setTimeout(refresh, 600); }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
    else refresh();
  })();
})();
